const init = () => {
  // The hero header links GTM
  const headerLink = document.getElementsByClassName('header-hero-links__item');

  Array.from(headerLink).forEach((element) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();

      const cTarget = e.currentTarget;

      // The item text.
      const theItemText = cTarget.querySelector('.header-hero-links__title').textContent;

      // The item href.
      const theItemHref = cTarget.querySelector('.header-hero-links__link').href;

      // Set the datLayer content.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'anchorClicks',
        ctaName: theItemText,
      });

      // Fire the original href.
      window.location.href = theItemHref;
    });
  });
};
export { init };
